export default __webpack_public_path__ + "static/media/virtual_services_code_en.078b72cc.png";